@if (initialized && formGroup) {

  <div class="p-2" [formGroup]="formGroup">
    <div class="mx-auto">
      <div class="surface-card border-round-2xl w-full">

<!--        <div class="flex justify-content-center mb-5">-->
<!--        <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-orange-50">-->
<!--          <i class="pi pi-lock text-orange-600 text-5xl"></i>-->
<!--        </span>-->
<!--        </div>-->

<!--        <div class="text-center mb-6">-->
<!--          <div class="text-color text-3xl font-semibold mb-2">Neues Passwort vergeben</div>-->
<!--          <span class="text-600 font-medium line-height-3 text-color-secondary">Hier kannst du ein neues Passwort vergeben.</span>-->
<!--        </div>-->

        <div class="mb-4">
          <label for="oldPassword" class="block text-900 font-medium mb-2">Altes Passwort</label>
          <p-password id="oldPassword" formControlName="oldPassword"
                      placeholder="Passwort eingeben" styleClass="w-full" inputStyleClass="w-full"
                      [toggleMask]="true" [feedback]="false"></p-password>
        </div>

        <div class="mb-4">
          <label for="newPassword" class="block text-900 font-medium mb-2">Neues Passwort</label>
          <p-password id="newPassword"
                      (focusout)="handleCheckPassword()"
                      (input)="handlePasswordMatch()"
                      formControlName="newPassword"
                      placeholder="Passwort eingeben" styleClass="w-full" inputStyleClass="w-full"
                      [toggleMask]="true" [feedback]="false"></p-password>

          <div *ngIf="formGroup.get('newPassword')?.errors?.['invalidPassword']" class="text-red-500 mb-2 text-sm">
            {{ formGroup.get('newPassword')?.errors?.['invalidPassword'] }}
          </div>

        </div>

        <div class="mb-4">
          <label for="confirmPassword" class="block text-900 font-medium mb-2">Bestätige das Passwort</label>
          <p-password id="confirmPassword" (input)="handlePasswordMatch()" formControlName="confirmPassword"
                      placeholder="Passwort eingeben" styleClass="w-full" inputStyleClass="w-full"
                      [toggleMask]="true" [feedback]="false"></p-password>
          <div *ngIf="formGroup.get('confirmPassword')?.errors?.['passwordError']" class="text-red-500 mb-2 text-sm">
            {{ formGroup.get('confirmPassword')?.errors?.['passwordError'] }}
          </div>
        </div>
        <p-divider></p-divider>

        <div class="flex justify-content-end">
          <!--          <button class="w-10rem" pButton [disabled]="!formGroup.valid" pRipple label="Speichern" (click)="handleChangePassword()"></button>-->
          <app-button [busy]="busy"
                      [disabled]="!formGroup.valid"
                      [class]="'w-10rem'"
                      [label]="'Speichern'"
                      [showIcon]="false"
                      (onClick)="handleChangePassword()">
          </app-button>
        </div>

      </div>
    </div>


  </div>

}
